/**
 * Canal de eventos de sessão, no mesmo padrão pub/sub do loadingBus.
 *
 * Existe porque o requestApi e o sessionManager vivem fora do React e precisam
 * avisar o AuthContext (que é quem sabe encerrar a sessão e mostrar mensagem).
 */

export type MotivoFimSessao = "expirada" | "inatividade" | "outra-aba";

export type EventoSessao =
  | { tipo: "sessao-expirada"; motivo: MotivoFimSessao }
  | { tipo: "sessao-renovada"; user: any }
  /** `expiraEm` é um timestamp absoluto; `null` cancela o aviso em exibição. */
  | { tipo: "aviso-inatividade"; expiraEm: number | null };

type Listener = (evento: EventoSessao) => void;

const listeners = new Set<Listener>();

/**
 * Guarda para que uma rajada de 401 simultâneos produza um único encerramento
 * de sessão (e uma única notificação). Diferente do antigo `fallbackChecker`,
 * este guard é resetado no login e ao iniciar o sessionManager — senão a
 * segunda sessão da mesma aba ficaria sem tratamento.
 */
let fimJaNotificado = false;

const emit = (evento: EventoSessao) => {
  listeners.forEach((listener) => listener(evento));
};

export const authBus = {
  notificarSessaoExpirada(motivo: MotivoFimSessao) {
    if (fimJaNotificado) return;
    fimJaNotificado = true;
    emit({ tipo: "sessao-expirada", motivo });
  },
  notificarSessaoRenovada(user: any) {
    emit({ tipo: "sessao-renovada", user });
  },
  notificarAvisoInatividade(expiraEm: number | null) {
    emit({ tipo: "aviso-inatividade", expiraEm });
  },
  /** Chamado no signIn e ao iniciar o sessionManager. */
  resetar() {
    fimJaNotificado = false;
  },
  jaNotificouFim() {
    return fimJaNotificado;
  },
  subscribe(listener: Listener) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
